export var createEmptyVet = function (createUuid) {
    return {
        uuid: createUuid(),
        businessName: "",
        name: "",
        phone: "",
        email: "",
        address: "",
        active: true,
        deleted: false,
    };
};
